import { isEmpty } from "lodash";
import { Dispatch } from "react";
import { apiBaseUrl, networkCall } from "../../utils/networkCall";

export const GET_CONFIGURATION_DATA: string = "GET_CONFIGURATION_DATA";
export const SET_SELECTED_TEMPLATE = "SET_SELECTED_TEMPLATE";
export const GET_WA_NUMBER_DATA = "GET_WA_NUMBER_DATA";

export interface IActionType { type: string, payload: any }

export const getConfigurationData = () => {
    return (dispatch: Dispatch<any>) => {
        networkCall("get", `/failover/config`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    dispatch({ type: GET_CONFIGURATION_DATA, payload: res });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    console.log(error.response)
                }
            });
    }
}

export const getWaNumbersData = () => {
    return (dispatch: Dispatch<any>) => {
        networkCall("get", `/whatsapp/numbers?status=1`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    dispatch({ type: GET_WA_NUMBER_DATA, payload: res });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    console.log(error.response)
                }
            });
    }
}

export const saveConfiguration = (payload: any, callback: (flag: boolean, res: any) => void, method: "put" | "post") => {
    return (dispatch: Dispatch<any>) => {
        networkCall(method, `/failover/config`, apiBaseUrl.baseUrl, true, true, payload)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    callback(true, res);
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    callback(false, error?.response?.data);
                }
            });
    }
}


export const saveTemplate = (method: "post" | "put", channel: string, data: any, cb: (flag: boolean, message: string) => void) => {
    let URL = `/failover/template`;
    let dataTosend: any = {};
    let endPoint = apiBaseUrl.baseUrl;
    if (channel === "voice") {
        dataTosend.channel_name = channel;
        dataTosend.name = data.templateName;
        dataTosend.body = data.templateContent;
        dataTosend.meta_value = {
            language: data.language,
            speech_rate: data.speechRate
        };
    } else {
        if (channel === "sms") {
            endPoint = apiBaseUrl.apiUrl;
            dataTosend.content = data.templateContent;
            dataTosend.title = data.templateName;
            dataTosend.sender_id = data.senderId;
            dataTosend.template_id = data.templateId;
            dataTosend.purpose = "OTP";
            dataTosend = { data: [dataTosend] };
        } else if (channel === "email") {
            dataTosend.channel_name = channel;
            dataTosend.name = data.templateName;
            dataTosend.body = data.templateContent;
            dataTosend.meta_value = {
                // from: data.email,
                subject: data.subject
            }
        }
    }
    if (data.id) {
        dataTosend.id = data.id;
    }

    return (dispatch: Dispatch<any>) => {
        networkCall(method, URL, endPoint, true, true, dataTosend).then((res: any) => {
            if (res.error && isEmpty(res.error)) {
                cb(true, res.message);
            }
        }).catch((error) => {
            if (error?.response?.data) {
                cb(false, error?.response?.message)
            }
        });
    };
}

export const deleteConfiguration = (url: string, payload: any, callback: (flag: boolean, res: any) => void) => {
    return (dispatch: Dispatch<any>) => {
        networkCall("delete", url, apiBaseUrl.baseUrl, true, true, payload)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    callback(true, res);
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    callback(false, error?.response?.data);
                }
            });
    }
}

export function updateSelectedTemplate(templateId: string): IActionType {
    return { type: SET_SELECTED_TEMPLATE, payload: templateId };
}